module.exports = __webpack_public_path__ + "static/img/news6_1.03e6661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news6_1.jpg
// module id = tymb
// module chunks = 0